'use client';

import { useEffect, useRef, useState, type FC, type ReactNode } from 'react';
import { Button } from '../../../components/ui/Button';
import { FaSlidersH } from '../../../components/icons';

interface WikiFiltersRowProps {
  tabs: ReactNode;
  label: string;
  count: number;
  panelId: string;
  children: ReactNode;
}

// WHY: на телефоне вкладки категорий и кнопка фильтров в одной строке, форма раскрывается под строкой на всю ширину
export const WikiFiltersRow: FC<WikiFiltersRowProps> = ({ tabs, label, count, panelId, children }) => {
  const [open, setOpen] = useState(false);
  const tabsRef = useRef<HTMLDivElement>(null);

  // WHY: строка вкладок уже экрана — выбранная категория иначе прячется за кнопкой фильтров
  useEffect(() => {
    const current = tabsRef.current?.querySelector<HTMLElement>('[aria-current="page"]');
    const scroller = current?.closest('nav');
    if (!current || !scroller) return;
    const tab = current.getBoundingClientRect();
    const box = scroller.getBoundingClientRect();
    scroller.scrollBy({ left: tab.left - box.left - (box.width - tab.width) / 2 });
  }, []);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <div ref={tabsRef} className="min-w-0 flex-1">
          {tabs}
        </div>
        <Button
          type="button"
          variant="tertiary"
          size="m"
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((value) => !value)}
          className="h-11 shrink-0 gap-1.5 px-3.5 font-semibold lg:hidden"
        >
          <FaSlidersH aria-hidden size={14} className="text-label-secondary" />
          {label}
          {count > 0 && <span className="rounded-full bg-accent-blue px-2 text-[13px] font-semibold leading-[20px] text-white">{count}</span>}
        </Button>
      </div>
      <div id={panelId} hidden={!open} className="rounded-[22px] bg-bg-secondary p-4 lg:hidden">
        {children}
      </div>
    </div>
  );
};
